// ============================================================
// audio/musicDark.js — (legacy) dark procedural music
// ============================================================
// Only one MP3 (CHILL MUSIC) is used now. This module keeps the same
// export signature so callers don't need to change, but every "start"
// now just delegates to the single chill track — idempotent so the
// song never restarts when phases toggle.
import { startMusic } from './musicChill.js';

export function startDarkMusic() { startMusic(); }
